export default __webpack_public_path__ + "assets/front/scss/collaborative-indexation.8a16e2c77487d5ca6c8c3e69fd08a66d.css";